module.exports = __webpack_public_path__ + "media/images/shared/icon-association-white-512d8d432bd8f7e52c3cb5ca7c115a34.png";